/**
 * Firebase app initialisation
 *
 * Config values come from Vite env vars (see .env.local or Firebase console).
 * The Firebase project is: clutch-ocm-platform
 *
 * To get config values:
 *   Firebase console → Project settings → Your apps → Web app config
 *
 * Copy to .env.local (never commit this file):
 *   VITE_FIREBASE_API_KEY=...
 *   VITE_FIREBASE_AUTH_DOMAIN=clutch-ocm-platform.firebaseapp.com
 *   VITE_FIREBASE_PROJECT_ID=clutch-ocm-platform
 *   VITE_FIREBASE_STORAGE_BUCKET=clutch-ocm-platform.appspot.com
 *   VITE_FIREBASE_MESSAGING_SENDER_ID=...
 *   VITE_FIREBASE_APP_ID=...
 */

import { initializeApp, getApps } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID,
}

// Avoid re-initialising on hot-reload
const app  = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0]
export const auth = getAuth(app)
